import dateTimeHelper from '../../../Helpers/datetimeHelper';
import ValidityHelper from '../../../Helpers/ValidityHelper';

class OpportunityValidation {
  static GreaterThanToday(e) {
    let day = dateTimeHelper.removeTime();

    if (dateTimeHelper.convertToUtc(day) >= dateTimeHelper.convertToUtc(e))
      return 'Please specify a date greater than ' + dateTimeHelper.toYYYYsMMsDDWithIndefinite(day, '-');
  }

  static validityCheckerMsPartner(e, editedItem) {
    if (editedItem.IsMspartner === undefined || editedItem.IsMspartner === false) return '';
    if (!e || e.toString().trim() === '') return "This field can't be empty.";
    return '';
  }

  static EstimatedDayCheck(e, editedItem) {
    if (editedItem.StatusCode === '') {
      if (e === null || e === '') return '';

      return OpportunityValidation.GreaterThanToday(e);
    } else if (parseInt(editedItem.StatusCode) === 1) {
      if (e === null || e === '') return "This field can't be empty.";
      return OpportunityValidation.GreaterThanToday(e);
    } else {
      if (editedItem.StatusCode !== '') return ValidityHelper.forRequiredTextField(e);
    }
    return '';
  }

  static EstimatedCloseDay(e, editedItem) {
    if (editedItem.StatusCode === '') {
      if (e === null || e === '') return '';

      return OpportunityValidation.GreaterThanToday(e);
    } else if (parseInt(editedItem.StatusCode) === 1) {
      if (e === null || e === '') return "This field can't be empty.";

      if (dateTimeHelper.toYYYYsMMsDD(editedItem.EstStartOn) > dateTimeHelper.toYYYYsMMsDD(e))
        return (
          'Please specify a date greater than ' + dateTimeHelper.toYYYYsMMsDDWithIndefinite(editedItem.EstStartOn, '-')
        );

      return OpportunityValidation.GreaterThanToday(e);
    }

    if (dateTimeHelper.toYYYYsMMsDD(editedItem.EstStartOn) > dateTimeHelper.toYYYYsMMsDD(e))
      return (
        'Please specify a date greater than ' + dateTimeHelper.toYYYYsMMsDDWithIndefinite(editedItem.EstStartOn, '-')
      );

    return '';
  }

  static ActualDate(e, editedItem) {
    let StatusCode = parseInt(editedItem.StatusCode);
    if (StatusCode < 4 || StatusCode === 12) return false;

    return true;
  }

  static ActualStartOn(e, editedItem) {
    return '';
  }

  static ActualEndOn(e, editedItem) {
    if (editedItem.ActualStartOn === null || editedItem.ActualStartOn === '') return '';

    if (e === null || e === '') {
      return 'Please specify a date';
    }

    if (
      editedItem.MaximumOpportunityDuration &&
      dateTimeHelper.toYYYYsMMsDD(
        dateTimeHelper.addMonthsToDate(editedItem.ActualStartOn, editedItem.MaximumOpportunityDuration)
      ) < dateTimeHelper.toYYYYsMMsDD(e)
    ) {
      return (
        'Please specify a date smaller than ' +
        dateTimeHelper.toYYYYsMMsDD(
          dateTimeHelper.addMonthsToDate(editedItem.ActualStartOn, editedItem.MaximumOpportunityDuration),
          '-'
        )
      );
    }

    if (
      dateTimeHelper.toYYYYsMMsDD(dateTimeHelper.addDaysToDate(editedItem.ActualStartOn, 1)) >
      dateTimeHelper.toYYYYsMMsDD(e)
    ) {
      return (
        'Please specify a date greater than ' + dateTimeHelper.toYYYYsMMsDDWithIndefinite(editedItem.ActualStartOn, '-')
      );
    }
  }

  static ActualEndOnAdminEdit(e, editedItem) {
    if (editedItem.ActualEndOn === null || editedItem.ActualEndOn === '') return '';

    if (e === null || e === '') return 'Please specify a date';

    if (dateTimeHelper.toYYYYsMMsDD(e) < dateTimeHelper.toYYYYsMMsDDWithIndefinite(editedItem.ActualEndOn))
      return (
        'Please specify a date bigger than ' + dateTimeHelper.toYYYYsMMsDDWithIndefinite(editedItem.ActualEndOn, '-')
      );

    let ActualEndOn = dateTimeHelper.toYYYYsMMsDDWithIndefinite(
      dateTimeHelper.addMonthsToDate(editedItem.ActualEndOn, 2)
    );

    if (ActualEndOn < dateTimeHelper.toYYYYsMMsDD(e))
      return 'Please specify a date smaller than ' + dateTimeHelper.toYYYYsMMsDDWithIndefinite(ActualEndOn, '-');
  }
}

export default OpportunityValidation;
